export default __webpack_public_path__ + "static/media/img_baseBunnyCrochetRattle_grey.b5b07c4a.jpg";